module.exports = __webpack_public_path__ + "media/images/upozorneni-68b2736805716cda0974107a2f911786.png";